var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #3978bd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.6,
    y: 6.8,
    width: 80.8,
    height: 80.8,
    rx: 7.9,
    ry: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.6,
    y: 6.8,
    width: 80.8,
    height: 80.8,
    rx: 7.9,
    ry: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.1,77.8v7.9c1.3.7,2.8,1.2,4.6,1.5s3.6.5,5.5.5,3.7-.2,5.4-.5c1.7-.4,3.2-1,4.5-1.8s2.3-1.9,3.1-3.3,1.1-3,1.1-5-.2-2.7-.6-3.8-1-2-1.9-2.9c-.8-.8-1.8-1.6-2.9-2.3s-2.4-1.3-3.8-1.9c-1-.4-2-.8-2.8-1.2-.8-.4-1.5-.8-2.1-1.2-.6-.4-1-.9-1.3-1.3-.3-.5-.5-1-.5-1.6s0-1,.4-1.5.7-.8,1.2-1.1,1.1-.6,1.9-.7c.7-.2,1.6-.3,2.5-.3s1.4,0,2.1,0c.7,0,1.5.3,2.2.5s1.5.5,2.2.8,1.3.7,1.9,1.1v-7.4c-1.2-.5-2.5-.8-3.9-1s-3.1-.3-4.9-.3-3.7.2-5.3.6-3.2,1-4.4,1.9c-1.3.9-2.3,1.9-3,3.3-.7,1.3-1.1,2.9-1.1,4.8s.7,4.4,2,6c1.4,1.7,3.4,3.1,6.2,4.2,1.1.4,2.1.9,3,1.3s1.8.9,2.4,1.3c.7.5,1.2,1,1.6,1.5.4.5.6,1.2.6,1.9s0,1-.4,1.4-.6.8-1.1,1.1-1.1.6-1.9.8c-.7.2-1.6.3-2.6.3-1.7,0-3.4-.3-5.1-.9-1.7-.6-3.2-1.5-4.7-2.7h-.1ZM40.8,58.3h10.1v-6.5h-28.3v6.5h10.1v28.9h8v-28.9h.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeScript);
export default __webpack_public_path__ + "static/media/TypeScript.39a5143a13855fda9ccaf953fc670aa7.svg";
export { ForwardRef as ReactComponent };